import { Theme, Typography } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { NavMenuItem } from '../../../lib/constants/nav-menu-data';
import Link from '../../Utils/Link';

export type NavItemProps = {
    item: NavMenuItem;
    onClick?: () => void;
};

const NavItem = ({ item, onClick }: NavItemProps) => {
    const loc = useLocation();
    const isAllSame = item.activeUrls.some((u) => loc.pathname === u);

    const navItemStyle = (t: Theme) => ({
        color: isAllSame ? t.palette.primary.main : 'white',
        fontWeight: 600,
        fontSize: 14,
        textDecoration: 'none',
        transition: 'all 0.15s',
        ':hover': {
            color: t.palette.primary.main
        }
    });

    return (
        <Typography key={item.href}>
            <Link onClick={onClick} sx={navItemStyle} to={item.href}>
                {item.label}
            </Link>
        </Typography>
    );
};

export default NavItem;
